import { TextField, IconButton, Grid2 as Grid, Box } from "@mui/material";
import { getDurationInMinutes } from "../../../../utils/timeUtils";
import Icons from "../../../../assets/js/Icons";
import { memo, useMemo } from "react";

const SlotRow = memo(({ slot, onChange, onDelete, disabled }) => {

  const duration = useMemo(() => {
    return getDurationInMinutes(slot.start, slot.end);
  }, [slot.start, slot.end]);

  return (
    <>
      <Grid container spacing={1.5} alignItems="center">
        <Grid size="grow">
          <TextField 
            fullWidth
            type="time"
            size="small"
            name="start[]"
            label="Start time"
            value={slot.start}
            disabled={disabled}
            slotProps={{ input: { step: 60 } }}
            onChange={(e) => onChange("start", e.target.value)}
          />
        </Grid>
        <Grid size="grow">
          <TextField
            fullWidth
            type="time"
            name="end[]"
            size="small"
            label="End time"
            value={slot.end}
            disabled={disabled}
            slotProps={{ input: { step: 60 } }}
            onChange={(e) => onChange("end", e.target.value)}
          />
        </Grid>
        <Grid size="auto">
          <Box sx={{ fontSize: 14, fontWeight: "500" }}>
            {duration > 0 ? `${duration} min` : "--"}
          </Box>
        </Grid>
        <Grid size="auto">
          {onDelete !== null &&
            <IconButton size="small" onClick={onDelete}>
              <Icons.DeleteSolid color="error" />
            </IconButton>
          }
        </Grid>
      </Grid>
    </>
  );
});

export default SlotRow;